exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn{display:inline-block;height:30px;background:#fff;color:#333;padding:0 10px;border-radius:3px;line-height:30px;margin-left:50px;vertical-align:middle;cursor:pointer}.btn,.p2{font-size:14px}.p2{line-height:40px}.p2 span{font-size:16px;color:red;padding:0 3px}.notify{float:right;color:#fff;font-size:16px;margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d5adaf2","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/view/main/components/header-bar/header-bar.vue
// module id = BUbj
// module chunks = 131